module.exports = __webpack_public_path__ + "img/7.e80cc9b1.webp";